<template>
	<div class="row">
		<div class="container">
			<div v-if="newList" :class="[{'product-info-box__add-list-edit-name':true, 'invalid':!IsValid}]">
				<input type="text" placeholder="List Name" ref="inputTitle" v-model="InputValue" @keyup.enter="createWishlist()">
				<a class="product-info-box__add-list-btn js-product-info-box__add-list-btn" href="javascript:;" @click="createWishlist()">Save</a>
			</div>
			<a class="lists__boxes-new-list" href="javascript:;" @click="newList = !newList">
				<SvgIcon class="lists__boxes-new-list-icon" iconName="ico-clipboard-list"/>
				<span>Create new list</span></a>
		</div>
	</div>
</template>
<script>

import SvgIcon from '../../../base/SvgIcon/SvgIcon.vue';
import List from '../../../../store/Modules/List';

export default {
	props: ['wishRender'],
	data() {
		return {
			newList: false,
			InputValue: '',
			IsValid: true,
			loader: false,
		};
	},
	components: {
		SvgIcon
	},
	methods: {
		async createWishlist() {
			const val = this.$refs.inputTitle.value;
			if (val !== '' && this.IsValid && val.replace(/\s/g, '').length) {
				this.loader = true;
				this.$emit('checkLoader', this.loader);
				await this.$store.dispatch('createWishlistNoProduct', val);
        this.loader = false;
				this.$refs.inputTitle.value = '';
				this.newList = false;
			}
		},
	},
	watch: {
		InputValue() {
			this.IsValid = true;
			List.state.wishlist.forEach(function(v) {
				if (v.title === this.InputValue) {
					this.IsValid = false;
				}
			}.bind(this));
		}
	}
};
</script>

<style lang="scss" scoped>
.product-info-box__add-list-edit-name {
	display: flex;
	max-width: 260px;
	margin-bottom: 10px;
	box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
	position: absolute;
	right: 0;
	top: -100px;
	background: white;
	padding: 10px;
	height: 70px;
	width: 300px;
	border-radius: 5px;

	&::after {
		content: '';
		position: absolute;
		bottom: -12px;
		right: 20px;
		width: 0;
		height: 0;
		border-left: 12px solid transparent;
		border-right: 12px solid transparent;
		border-top: 12px solid $white;
	}

	@include mq($md) {
		input {
			width: 165px;
		}
	}

	&.invalid {
		input {
			color: red;
			border: 1px solid red;
		}

		a {
			display: none;
		}
	}
}
</style>
